import { ClientTitle } from '../models/request-and-responses/rest-api/enums/clientTitle';

interface IClientTitleLV {
    label: string;
    value: ClientTitle;
}

export class ClientTitles {
    static readonly [ClientTitle.Owner]: IClientTitleLV = {
        label: 'TITOLARE DELLA FORNITURA',
        value: ClientTitle.Owner
    };
    static readonly [ClientTitle.Other]: IClientTitleLV = {
        label: 'TITOLARE DI ALTRO DIRITTO',
        value: ClientTitle.Other
    };
    static readonly [ClientTitle.Administrator]: IClientTitleLV = {
        label: 'AMMINISTRATORE CONDOMINIO',
        value: ClientTitle.Administrator
    };
    static get list(): IClientTitleLV[] {
        return [
            ClientTitles[ClientTitle.Owner],
            ClientTitles[ClientTitle.Administrator],
            ClientTitles[ClientTitle.Other]
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/clientTitles.ts